import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setPageName } from '../reducers/pageSlice';
import { tabSlice } from '../reducers/dataCurationDashboard/tabs';
import TabFactory from '../components/tabs/TabFactory';

function DataCurationDashboard() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setPageName('Data Curation Dashboard'));
  }, []);

  return <TabFactory slice={tabSlice} />;
}

export default DataCurationDashboard;
